import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ChangeSubProjectStatusWidget from '../../../widgets/changeProjectStatus/ChangeSubProjectStatusWidget'
import { getChangeSubProjectStatusPage } from '../../../redux/actions/changeProjectStatus'
import HistoryChangeSubProjectStatusWidget from '../../../widgets/changeProjectStatus/HistoryChangeSubProjectStatusWidget'

export default function ChangeSubProjectStatus(props) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getChangeSubProjectStatusPage(proposalId)
      setSchema(_schema.model)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProject>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {schema?.forms?.changeProjectStatus && (
            <ChangeSubProjectStatusWidget
              disabledForm={schema.forms.changeProjectStatus.disabled}
              schema={schema.forms.changeProjectStatus}
              // onChangeIsEdit={(_isEdit) =>
              //   handleOnChangeIsEdit('changeProjectStatus', _isEdit, setIsEditWidget)
              // }
            />
          )}
          <br />
          {schema?.forms?.dataLists && schema?.forms?.dataLists?.dataVal?.length > 0 && (
            <HistoryChangeSubProjectStatusWidget
              schema={schema?.forms?.dataLists}
              loading={isLoading}
            />
          )}

          <br />
        </SidebarProposal>
      )}
    </>
  )
}
